import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { GuiService } from 'src/app/services/gui.service';
import { NotificationService } from 'src/app/services/notification.service';
import { RestService } from 'src/app/services/rest.service';
import * as moment from 'moment';
import { PopupModalComponent } from '../shared/popup-modal/popup-modal.component';
import { Location } from '@angular/common';

@Component({
  selector: 'vex-notifications',
  templateUrl: './notifications.component.html',
  styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {
  selectedNotifications: any = [];
  allSelected: boolean = false;

  constructor(public notificationService: NotificationService, public guiService: GuiService, public translate: TranslateService, private dialog: MatDialog, private restService: RestService, private location: Location) { }

  ngOnInit() {
    this.guiService.showSpinner = false;
  }

  selectNotification(notificationId){
    if(this.selectedNotifications.includes(notificationId)){
      let index = this.selectedNotifications.indexOf(notificationId);
      this.selectedNotifications.splice(index, 1);
      this.allSelected = false;
    }else{
      this.selectedNotifications.push(notificationId);
    }
  }

  selectAllNotification(){
    if(!this.allSelected){
      this.notificationService.notifications.forEach(notification => {
        const notificationId = notification.notificationId;
        this.selectedNotifications.push(notificationId);
      });
      this.allSelected = true;
    }else{
      this.selectedNotifications = [];
      this.allSelected = false;
    }
  }

openNotification(notification: any): void {
  const lang = this.translate.currentLang.toUpperCase();
  const title = notification.notification.i18nTitle
    ? notification.notification.i18nTitle[lang]
    : notification.notification.i18nSubject[lang];

  const subTitle = notification.notification.i18nMessage[lang];

  this.dialog.open(PopupModalComponent, {
    disableClose: true,
    panelClass: 'custom-modal',
    data: {
      title,
      date: this.getTime(notification.notification.notificationDate),
      subTitle,
      buttonTitle: this.translate.instant("NOTIFICATIONS.ARCHIVE-BTN"),
      closeBtnTop: true,
      callbackBtn: 'archive'
    }
  }).afterClosed().subscribe(result => {
    if (result?.callback === 'archive') {
      console.debug('Archivia la notifica');
      this.archiveNotification(notification.notificationId);
    }
  });
}

  getTime(date:any){
    return moment(date).fromNow()
  }

  archiveNotification(notificationId){
    const param = {
      userId: this.guiService.userLogged.user.id,
      notificationId: notificationId
    }
    this.restService.postService('node', '/archive-notification',param).subscribe((ris)=>{
      this.notificationService.getNotifications();
    })
  }

  archiveMultipleNotifications(){
    const param = {
      userId: this.guiService.userLogged.user.id,
      notificationIds: this.selectedNotifications
    }
    this.notificationService.notificationSpinner = true;
    this.restService.postService('node', '/archive-multiple-notifications',param).subscribe((ris)=>{
      this.selectedNotifications = [];
      this.notificationService.getNotifications();
    })
  }

  goBack(): void {
    this.location.back();
  }

}
